import React from 'react';

export const Note: React.FC = () => (
    <div className='foot'>
        *Please remember that <strong>this is a guide</strong>.
        If you think you're suffering from any changes to your blood pressure,
        please consult a GP before making any diet and lifestyle changes
    </div>
)